export default __webpack_public_path__ + "static/media/3.ef722427.png";